<template>
	<dl>
		<dt>versionDeprecated</dt>
		<dd i18n>Версия Вашего приложения устарела. Приложение будет автоматически обновлено.</dd>
		<dt>sentDocumentMessage</dt>
		<dd i18n>Документ обрабатывается. Страница будет обновлена.</dd>
	</dl>
</template>
